import React from "react";
import { ListItem, ListItemButton, ListItemIcon, ListItemText, Skeleton } from "@mui/material";


export default function () {
    return <React.Fragment>
        {[...Array(5)].map(index => {
            return <ListItem disablePadding key={index}>
                <ListItemButton>
                    <ListItemIcon>
                        <Skeleton variant="circular" width={25} height={25} />
                    </ListItemIcon>
                    <ListItemText primary={<Skeleton height={20} width={100} />} />
                </ListItemButton>
            </ListItem>
        })}
    </React.Fragment>
}